import { z } from 'zod';

/** País ISO 3166-1 alpha-2 en mayúsculas (`PE`, `CL`, …). */
export const CountryCodeSchema = z
  .string()
  .length(2)
  .regex(/^[A-Z]{2}$/, { message: 'País ISO 3166-1 alpha-2 en mayúsculas' });
export type CountryCode = z.infer<typeof CountryCodeSchema>;

/**
 * Zona horaria IANA (`America/Lima`). El catálogo se valida en la API con
 * `Intl.supportedValuesOf('timeZone')` → `422 INVALID_TIMEZONE`.
 */
export const TimezoneSchema = z.string().min(1).max(64);
export type Timezone = z.infer<typeof TimezoneSchema>;
